import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../../baseClasses/BaseComponent';
import UserAvatar from '../../../components/UserAvatar';
import SelectUserComboBox from '../../../components/SelectUserComboBox';
import animator from '../../../helpers/animator';
import ReferenceDocs from '../ReferenceDocs';
import TaskInventory from '../TaskInventory';
import expandor from '../../../assets/images/expandor.svg';
import ComboBox from '../../../components/ComboBox';
import contractor from '../../../assets/images/contractor.svg';
import Animate from '../../../components/Animate';
import dataModel from '../../../models/DataModel';
import DataSource from '../../../dao/DataSource/DataSource';
import TaskActivity from '../TaskActivity';
import './EditTaskDetails.scss';
import Input from '../../Input';
import Textarea from '../../Textarea';

const taskDescriptor = {
  task: {
    completion_criteria: {
      attachments: {
        additionalFields: ['upload', 'photo_longitude', 'photo_latitude', 'photo_taken_at'],
        conversions: {},
        user: {}, 
      } ,
      comments: { user: { additionalFields: ['profile_image'] } },
      event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
      form_fields: {},
    },
    reference_documents: {},
    user_task_assignments: {
      user: { additionalFields: ['profile_image'], 
        companies: {},
      },
    },
    build_owners: { companies: {} },
    inventory_items: {  inventory: {} },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
  },
};

const projectDescriptor = {
  project: {
    project_users: { user: { additionalFields: ['profile_image'], role: {}, companies: {} } },
    users: {
      additionalFields: ['profile_image'], role: { }, companies: { }, company_vendor_users: { vendor_user: { additionalFields: ['profile_image'], role: { }, companies: { } } }, 
    },
  },
};

const projectTemplateDescriptor = {
  project_template: {},
};

export default class EditTaskDetails extends BaseComponent {
  
  constructor(props) {
    super(props);
    
    EditTaskDetails.propTypes = {
      task: PropTypes.object.isRequired,
     
      // an array of objects containing normalized information from both Inventory and InventoryItem 
      inventoryItems: PropTypes.arrayOf(PropTypes.object),
      // function to delete an inventory item
      deleteInventoryItem: PropTypes.func,
    };

    this.animator = new animator();
    this.state = { menu: null, descriptionExpanded: true, durationExpanded: true, preserveEditTask: false };
  }

  handleTaskUpdate(task, action, acData) {
    if (acData && this.state.preserveEditTask) {
      // merge the changes
      task.user_task_assignments = this.state.task.user_task_assignments;
      task.deadline_from_dependency = this.state.task.deadline_from_dependency;
      task.notes = this.state.task.notes;
    }
    this.setState({ task });
    if (task.deadline_from_dependency) {
      this.setState({ freqSelection: { type: 2, name: 'should be completed' }, daysInput: Math.floor(task.deadline_from_dependency / 24) });
    }
    else {
      this.setState({ freqSelection: { type: 1, name: 'has no duration set' }, daysInput: null });
    }
  }

  handleProjectUpdate(project, action, acData) {
    this.setState({ project });
  }

  handleProjectTemplateUpdate(projectTemplate, action, acData) {
    this.setState({ projectTemplate });
  }

  componentDidMount() {
    super.componentDidMount(this);
    if (this.props.task) {
      this.taskDataSource = new DataSource('Task', this.props.task, taskDescriptor, this.handleTaskUpdate);
      this.taskDataSource.get();
    }
    if (this.props.project) {
      this.projectDataSource = new DataSource('Project', this.props.project, projectDescriptor, this.handleProjectUpdate);
      this.projectDataSource.get();
    }
    else if (this.props.projectTemplate) {
      this.projectTemplateDataSource = new DataSource('ProjectTemplate', this.props.projectTemplate, projectTemplateDescriptor, this.handleProjectTemplateUpdate);
      this.projectTemplateDataSource.get();
    }
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
    if (this.projectTemplateDataSource) {
      this.projectTemplateDataSource.release();
      this.projectTemplateDataSource = null;
    }
  }
  
  componentDidUpdate(prevProps) {
    if (this.completionStepName && this.setFocus) {
      this.setFocus = false;
      this.completionStepName.focus();
    }
    if (prevProps.task && this.props.task && prevProps.task.id != this.props.task.id) {
      if (this.taskDataSource) {
        this.taskDataSource.release();
      }
      this.taskDataSource = new DataSource('Task', this.props.task, taskDescriptor, this.handleTaskUpdate);
      this.taskDataSource.get();
    }
    if (!prevProps.project && (this.props.project || (prevProps.project && this.props.project && prevProps.project.id != this.props.project.id))) {
      if (this.projectDataSource) {
        this.projectDataSource.release();
      }
      this.projectDataSource = new DataSource('Project', this.props.project, projectDescriptor, this.handleProjectUpdate);
      this.projectDataSource.get();
    }
    if (!prevProps.projectTemplate && (this.props.projectTemplate || (prevProps.projectTemplate && this.props.projectTemplate && prevProps.projectTemplate.id != this.props.projectTemplate.id))) {
      if (this.projectTemplateDataSource) {
        this.projectTemplateDataSource.release();
      }
      this.projectTemplateDataSource = new DataSource('ProjectTemplate', this.props.projectTemplate, projectTemplateDescriptor, this.handleProjectTemplateUpdate);
      this.projectTemplateDataSource.get();
    }
  }

  makeUserAssignment(type, selectedOption) {
    let editedTask = this.state.task;

    let userInTaskForType = editedTask.user_task_assignments.find(uta => {
      if (uta.assignment_type == type) {
        return uta.user_id == selectedOption.user.id || (uta.user && uta.user.id == selectedOption.user.id);
      }
      else {
        return null;
      }
    });
    if (selectedOption.selected) {
      if (type == 'notify') {
        if (!userInTaskForType) {
          editedTask.user_task_assignments.push({ assignment_type: type, user: selectedOption.user, toBeAdded: true });
        }
      }
      else {
        let userInTaskNotNotify = editedTask.user_task_assignments.find(uta => {
          return (
            uta.assignment_type != 'notify' && 
            (uta.user_id == selectedOption.user.id || (uta.user && uta.user.id == selectedOption.user.id)) &&
            !uta.toBeDeleted
          );
        });
        if (!userInTaskNotNotify) {
          editedTask.user_task_assignments.push({ assignment_type: type, user: selectedOption.user, toBeAdded: true });
        }
      }
    }
    else {
      if (userInTaskForType) {
        if (userInTaskForType.id) {
          userInTaskForType.toBeDeleted = true;
        }
        else {
          const index = editedTask.user_task_assignments.indexOf(userInTaskForType);
          if (index >= 0) {
            editedTask.user_task_assignments.splice(index, 1);
          }
        }
      }
    }

    this.setState({ preserveEditTask: true, task: editedTask });
    this.props.editCallBack(editedTask);
    dataModel.dataChanged = true;
  }

  handleReviewersSelection(users, selectedOption) {
    this.makeUserAssignment('reviewer', selectedOption);
  }

  handleApproversSelection(users, selectedOption) {
    this.makeUserAssignment('approver', selectedOption);
  }

  handleNotifyUsersSelection(users, selectedOption) {
    this.makeUserAssignment('notify', selectedOption);
  }

  handleFieldUsersSelection(users, selectedOption) {
    this.makeUserAssignment('field_user', selectedOption);
  }

  createMemberArray(userList, type) {
    if (userList) {
      return userList.map(user => {
        return <UserAvatar id={'user-avatar-task-crud' + type + user.id} key={'user-avatar-task-crud' + type + user.id} user={user} small={true} />;
      });
    }
    else {
      return null;
    }
  }

  handleDescriptionClick() {
    if (!this.state.descriptionExpanded) {
      this.setState({ animateExpand: true, descriptionExpanded: true });

    } else {
      this.setState({ animateContract: true, descriptionExpanded: false });
    }
  }

  handleFinishAnimation() {
    if (this.state.animateContract) {
      this.setState({
        animateContract: false,
      });
    }
    else {
      this.setState({
        animateExpand: false,
      });
    }
  }
  
  handleFinishDurationAnimation() {
    if (this.state.animateDurationContract) {
      this.setState({
        animateDurationContract: false,
      });
    }
    else {
      this.setState({
        animateDurationExpand: false,
      });
    }
  }
  
  handleNotesChanged(e) {
    let editedTask = this.state.task;
    editedTask.notes = e.target.value;
    this.setState({ preserveEditTask: true });
    this.props.editCallBack(editedTask);
    dataModel.dataChanged = true;
  }

  handleSelectFreq(type, optionSelected) {
    this.setState({  });
    let { task } = this.state;
    task.deadline_from_dependency = optionSelected.type == 1 ? 0 : 24;
    this.setState({ freqSelection: optionSelected, daysInput: Math.floor(task.deadline_from_dependency / 24), preserveEditTask: true });
    this.props.editCallBack(task);
  }

  handleDurationClick() {
    if (!this.state.durationExpanded) {
      this.setState({ animateDurationExpand: true, durationExpanded: true });

    } else {
      this.setState({ animateDurationContract: true, durationExpanded: false });
    }
  }

  handleDaysInput(e) {
    let { task } = this.state;
    let days = e.target.valueAsNumber;
    if (Number.isNaN(days)) {
      task.deadline_from_dependency = 0; // convert ot hours
      days = '';
    }
    else {
      task.deadline_from_dependency = days * 24; // convert ot hours
    }
    this.setState({ daysInput: days, task, preserveEditTask: true });
    this.props.editCallBack(task);
    dataModel.dataChanged = true;
  }

  handleCreateTaskDuration(task) {
    const { project, projectTemplate } = this.state;
    if ((project && project.config && project.config.duration) ||
        (projectTemplate && projectTemplate.config && projectTemplate.config.duration)) {
      let { freqSelection, daysInput } = this.state;
      const freqOptions = [{ type: 1, name: 'has no duration set' }, { type: 2, name: 'should be completed' }];
      let durationIcon = expandor;
      if (this.state.durationExpanded) {
        durationIcon = contractor;
      }

      if (!freqSelection) {
        freqSelection = freqOptions[0];
      }
  
      return <div className='task-duration-container' id="task-duration-container">
      <div className="task-duration-header">
      <div className='task-duration-label'>
        {'Task Forecasting'}
        <img className="expand-collapse-icon" src={durationIcon} alt='expand' onClick={this.handleDurationClick} />
        </div>
        </div>

        <div className={'task-duration'}>
          <div className='task-duration-line'>
            <div className='task-duration-text'>This Task</div>
            <ComboBox key='freq-selector' id='freq-selector' options={freqOptions} currentOption={freqSelection}
              handleSelection={this.handleSelectFreq}
              hasBorder={false}
              underlined={true}
              hideCaret={true}
              height={18}
              width={250}
              inputWidth={+freqSelection.type == 2 ? 143 : 130}
              menuHeight={50}
              dontSortMenu={true}
              displayFontStyle={{ fontSize: '12px' }}
            />
          </div>
          <div className='task-duration-line'>
          {freqSelection.type == 2 ?
              <Input className='days-input' type='number' min={1} step={1} value={daysInput} onChange={this.handleDaysInput} ref={(e) => {
                if (e){
                  e.focus();
                }
              }}/>
            : null}
          {freqSelection.type == 1 ?
                <div className='task-duration-text'>and should be completed on the same day as the previous task.</div>
                :
                <div className='task-duration-text'>day(s) after the previous task is completed.</div>
              }
            </div>
        </div>
      </div>;
    }
    else {
      return null;
    }
  }

  handleCreateActivityList() {
    const { task } = this.state;
    return task ? <TaskActivity task={task} /> : null;
  }

  handleActivityClick() {
    this.setState({
      activityExpanded: !this.state.activityExpanded,
    });
  }

  render() {

    const { inventoryItems, inventoryEnabled } = this.props;
    const { project, task } = this.state;

    if (!task){
      return null;
    }

    let notifyUsers = null;
    let reviewerUsers = null;
    let approverUsers = null;
    let fieldUsers = null;

    let fieldUserFilter = [];
    let reviewerFilter = [];
    let approverFilter = [];
    let notifyFilter = [];
    let assignedToAvatars = null;
    let approverAvatars = null;
    let notifyAvatars = null;
    let reviewerAvatars = null;

    let activityIcon = expandor;
    let activityList;

    activityList = this.handleCreateActivityList();
    if (this.state.activityExpanded) {
      activityIcon = contractor;
    }

    if (project) {
      notifyUsers = task.user_task_assignments ? task.user_task_assignments.filter(user_task_assignment => {
        if (user_task_assignment.user && user_task_assignment.assignment_type == 'notify' && !user_task_assignment.toBeDeleted) {
          return true;
        }
        else {
          return false;
        }
      }).map(ut => {
        return ut.user;
      }) : [];

      reviewerUsers = task.user_task_assignments ? task.user_task_assignments.filter(user_task_assignment => {
        if (user_task_assignment.user && user_task_assignment.assignment_type == 'reviewer' && !user_task_assignment.toBeDeleted) {
          return true;
        }
        else {
          return false;
        }
      }).map(ut => {
        return ut.user;
      }) : [];

      approverUsers = task.user_task_assignments ? task.user_task_assignments.filter(user_task_assignment => {
        if (user_task_assignment.user && user_task_assignment.assignment_type == 'approver' && !user_task_assignment.toBeDeleted) {
          return true;
        }
        else {
          return false;
        }
      }).map(ut => {
        return ut.user;
      }) : [];

      fieldUsers = task.user_task_assignments ? task.user_task_assignments.filter(user_task_assignment => {
        return (user_task_assignment.user && user_task_assignment.assignment_type == 'field_user' && !user_task_assignment.toBeDeleted);
      }).map(ut => {
        return ut.user;
      }) : [];

      fieldUsers.filter(fieldUser => {
        reviewerFilter.push(fieldUser);
        approverFilter.push(fieldUser);
        return true;
      });

      reviewerUsers.filter(reviewer => {
        fieldUserFilter.push(reviewer);
        approverFilter.push(reviewer);
        return true;
      });

      approverUsers.filter(approver => {
        fieldUserFilter.push(approver);
        reviewerFilter.push(approver);
        return true;
      });

      notifyUsers.filter(notify => {
        return true;
      });

      if (fieldUsers.length > 1) {
        const assignedToImages = this.createMemberArray(fieldUsers, 'assigned');
        assignedToAvatars = <div className="member-display">
          <div className="member-array">
            {assignedToImages}
          </div>
        </div>;
      }

      if (reviewerUsers.length > 1) {
        const reviewerImages = this.createMemberArray(reviewerUsers, 'reviewer');
        reviewerAvatars = <div className="member-display">
          <div className="member-array">
            {reviewerImages}
          </div>
        </div>;
      }

      if (approverUsers.length > 1) {
        const approverImages = this.createMemberArray(approverUsers, 'approver');
        approverAvatars = <div className="member-display">
          <div className="member-array">
            {approverImages}
          </div>
        </div>;
      }

      if (notifyUsers.length > 1) {
        const notifyImages = this.createMemberArray(notifyUsers, 'notify');
        notifyAvatars = <div className="member-display">
          <div className="member-array">
            {notifyImages}
          </div>
        </div>;
      }
    }

    let referenceDocs = <ReferenceDocs task={this.state.task} editing={this.props.editing} updatedReferenceDocuments={this.props.updatedReferenceDocuments} updateReferenceDocument={this.props.updateReferenceDocument} updateEditFlag={this.props.updateEditFlag} build={this.props.build} />;
    let descriptionIcon = expandor;
    if (this.state.descriptionExpanded) {
      descriptionIcon = contractor;
    }

    let animate = null;
    if (this.state.animateExpand) {
      animate = <Animate component_id="description-container" key="animate-expand" property={{ height: { startVal: 32, endVal: 121 } }} completionCallback={this.handleFinishAnimation}
        duration={250} />;
    }
    else if (this.state.animateContract) {
      animate = <Animate component_id="description-container" key="animate-contract" property={{ height: { startVal: 121, endVal: 32 } }} completionCallback={this.handleFinishAnimation}
        duration={250} />;
    }

    if (this.state.animateDurationExpand) {
      animate = <Animate component_id="task-duration-container" key="animate-expand" property={{ height: { startVal: 32, endVal: 86 } }} completionCallback={this.handleFinishDurationAnimation}
        duration={250} />;
    }
    else if (this.state.animateDurationContract) {
      animate = <Animate component_id="task-duration-container" key="animate-contract" property={{ height: { startVal: 86, endVal: 32 } }} completionCallback={this.handleFinishDurationAnimation}
        duration={250} />;
    }

    let taskDuration = this.handleCreateTaskDuration(task);

    return (

      <div id={this.props.id} className="task-settings">
        {animate}
          <div className="settings-header">
            <div className="caption">{this.textMap.taskDetails}</div>
          </div>
          <div className="edit-container">
            <hr className="separator" />
            {project &&
            <div className="edit-section">
              <div className={'double-entry-field' + (fieldUsers.length > 1 ? ' double-entry-field--avatars-below' : '')}>
                <div className="half-field input-enabled">
                  <div className="label">{fieldUsers && fieldUsers.length > 1 ? 'ASSIGNED TO' : this.textMap.assignedTo.toUpperCase()}</div>
                  <div className="field">
                    <SelectUserComboBox
                      key="field-user"
                      noFocus={true}
                      width={196}
                      hasBorder={false}
                      multiSelect={true}
                      menuBelow={true}
                      height={24}
                      small={true}
                      handleMultipleSelection={this.handleFieldUsersSelection}
                      selectedUsers={fieldUsers}
                      users={project ? project.users : null}
                      filterUsers={fieldUserFilter}
                    />
                  </div>
                  {assignedToAvatars}
                </div>
                <div className={'half-field input-enabled'}>
                  <div className="label">{this.textMap.reviewer.toUpperCase()}</div>
                  <div className={'field '}>
                    <SelectUserComboBox
                      key="reviewer-user"
                      noFocus={true}
                      width={196}
                      hasBorder={false}
                      multiSelect={true}
                      menuBelow={true}
                      height={24}
                      small={true}
                      handleMultipleSelection={this.handleReviewersSelection}
                      selectedUsers={reviewerUsers}
                      users={project ? project.users : null}
                      filterUsers={reviewerFilter}
                    />
                </div>
                {reviewerAvatars}
                </div>
              </div>
              <div className={'double-entry-field' + (notifyUsers.length > 1 ? ' double-entry-field--avatars-below' : '')}>
                {/* NOTE: Approver  commented out for now so it can be reverted if needed
                <div className={"half-field input-enabled "}>
                  <div className="label">{this.textMap.approver.toUpperCase()}</div>
                  <div className="field">
                    <SelectUserComboBox
                      key="approver-user"
                      noFocus={true}
                      width={196}
                      hasBorder={false}
                      multiSelect={true}
                      menuBelow={true}
                      height={24}
                      small={true}
                      handleMultipleSelection={this.handleApproversSelection}
                      selectedUsers={approverUsers}
                      users={project ? project.users : null}
                      filterUsers={approverFilter}
                    />
                  </div>
                  {approverAvatars}
                </div> */}
                <div className={'half-field input-enabled notify-field'}>
                  <div className="label">TASK UPDATE NOTIFICATIONS</div>
                  <div className="field notify-field">
                    <SelectUserComboBox
                      key="notify-user"
                      width={196}
                      noFocus={true}
                      hasBorder={false}
                      multiSelect={true}
                      selectedUsers={notifyUsers}
                      menuBelow={true}
                      handleMultipleSelection={this.handleNotifyUsersSelection}
                      height={24}
                      small={true}
                      users={project ? project.users : null}
                      fil terUsers={notifyFilter}
                    />
                  </div>
                  {notifyAvatars}
                </div>
              </div>
            </div>        
          }
          {project &&
            <div className='separator' />
          }

          <div className='description-container' id="description-container">
            <div className="description-header">
            <div className='description-label'>
              {this.textMap.description.toUpperCase()}
              <img className="expand-collapse-icon" src={descriptionIcon} alt='expand' onClick={this.handleDescriptionClick} />
              </div>
              </div>
            <div className={'description-input'}>
              <Textarea value={this.state.task && this.state.task.notes ? this.state.task.notes : ''} onChange={this.handleNotesChanged}/>
            </div>
          </div>

          {taskDuration ? <div className='separator' /> : null}
          {taskDuration ? taskDuration: null}

          <hr className="separator" />
          {referenceDocs}
          <hr className="separator" />
          {
            inventoryEnabled && project &&
            <TaskInventory 
              items={inventoryItems || []} 
              mobile={false} 
              editMode={true}
              deleteInventoryItem={this.props.deleteInventoryItem}
            />
          }
          {project &&
            <div className='activity-container'>
              <div className='activity-label'>
                {this.textMap.activity.toUpperCase()}
                <img src={activityIcon} alt='expand' onClick={this.handleActivityClick} />
              </div>
              <div className={'activity ' + (this.state.activityExpanded ? '' : 'closed')} >
                {activityList ? activityList : <div className='activity-empty'>No Activity found</div>}
              </div>
            </div>
          }
          {project &&
            <div className='horizontal-divider' />}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/EditTaskDetails/index.js